import React, { useEffect, useState } from 'react'
import { IconButton } from '@mui/material';
import { SubmitButton as Button } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { selectCustomStyles } from 'components/common/Select';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { AsyncPaginate } from 'react-select-async-paginate';
import { fetchStates } from 'slices/stateSlice';
import { Select } from 'components/common/Select';

const DynamicFacilities = ({ item }) => {
    const { control, formState: { errors }, watch, setValue } = useFormContext()
    const dispatch = useDispatch()
    const [dynamicArray, setDynamicArray] = useState([]);
    const [associateAddress, setAssociateAddress] = useState({});
    const [allStates, setAllStates] = useState([]);


    console.log(watch("facilities"), 'associateAddress');
    // #region States dropdown
    const filteredStatesLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchStates(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        const options = result.data.map(val => ({
            value: val.id,
            label: val.name,
        }))
        setAllStates(options)
        return {
            options: options,
            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion

    // const handleCities = async (val, index) => {
    //     const result = await dispatch(fetchStates(1, {}, true, true));
    //     const cities = result.data.find(state => state.id === val)?.cities;
    //     setDynamicArray(prevArray => {
    //         const newVariants = [...prevArray];
    //         newVariants[index].cities = cities?.map(val => ({
    //             label: val.name,
    //             value: val.id
    //         }));
    //         return newVariants;
    //     });
    // }
    const handleCities = async (val, index) => {
        const result = await dispatch(fetchStates(1, {}, true, true));
        const cities = result.data.find(state => state.id === val)?.cities;

        setDynamicArray(prevArray => {
            const newVariants = [...prevArray];

            if (!newVariants[index]) return prevArray;

            newVariants[index].cities = cities?.map(val => ({
                label: val.name,
                value: val.id
            }));

            return newVariants;
        });
    }

    // useEffect(() => {
    //     if (item?.facilities?.length) {
    //         item.facilities.forEach((val, index) => {
    //             if (val.state) {
    //                 handleCities(val.state.id, index);
    //             }
    //         });
    //     }
    // }, [item , associateAddress]);

    useEffect(() => {
        if (!item?.facilities?.length) return;

        item.facilities.forEach((val, index) => {
            if (val.state) {
                handleCities(val.state.id, index);
            }
        });
        }, [item]);
    

    useEffect(() => {
        setDynamicArray(watch("facilities") || []);
    }, [watch("facilities")])

    const handleAdd = React.useCallback(() => {
        setDynamicArray(prevArray => {
            const newVariants = [...prevArray, {
                id: null,
                name: "",
                address: associateAddress[prevArray.length] ? "" : undefined,
                state_id: associateAddress[prevArray.length] ? null : undefined, 
                city_name: associateAddress[prevArray.length] ? null : undefined,  
                zipcode: associateAddress[prevArray.length] ? "" : undefined,  
            }];
    
            setValue("facilities", newVariants);
            return newVariants;
        });
    }, [setValue, associateAddress]);
    

    const handleRemove = (index) => {
        const newVariants = [...dynamicArray];
        newVariants.splice(index, 1);

        const newAssociate = {};
        newVariants.forEach((_, i) => {
            newAssociate[i] = associateAddress[i >= index ? i + 1 : i] || false;
        });
        
        setDynamicArray(newVariants);
        setAssociateAddress(newAssociate);
        setValue("facilities", newVariants);
    }

    
    const handleCheckboxChange = (index) => {
        setAssociateAddress(prevState => ({
            ...prevState,
            [index]: !prevState[index]  // ✅ Toggle current state
        }));
    
        setDynamicArray(prevArray => {
            const newVariants = [...prevArray];
    console.log(associateAddress, 'associateAddress' , index , 'index')
            if (associateAddress[index]) {
                // ✅ Reset fields when unchecking
                newVariants[index] = {
                    ...newVariants[index],
                    address: undefined,
                    state_id: undefined,
                    city_name: undefined,
                    zipcode: undefined,
                };
    
                // ✅ Directly update React Hook Form
                // setValue(`facilities.${index}.address`, undefined);
                // setValue(`facilities.${index}.state_id`, undefined);
                // setValue(`facilities.${index}.city_name`, undefined);
                // setValue(`facilities.${index}.zipcode`, undefined);
            }
    
            return newVariants;
        });
    };
    console.log(associateAddress, 'associateAddresssssssss')

    useEffect(() => {
        const newState = {};
        if (item?.facilities) {
            item.facilities.forEach((facility, idx) => {
                if (facility.address) {
                    newState[idx] = true;
                }
            });
        }
              const formattedDurations = (item?.facilities || []).map((val, index) => ({
            id: val?.id,
            name: val?.abbreviation || '',
            address: newState[index] == true ? val?.address : '',
            state_id: newState[index] == true ? val?.state?.id : '',
            city_name: newState[index] == true ? val?.city_name : '',
            zipcode: newState[index] == true ? val?.zipcode : '',
        }));
        setValue('facilities', formattedDurations);
        setAssociateAddress(newState);

        if (item?.facilities?.length) {
            const stateArray = item?.facilities.map((val) => ({
                value: val?.state?.id,
                label: val?.state?.name
            }));

            setAllStates(stateArray);
        }

    }, [item?.facilities]);

    // useEffect(() => {
        // const formattedDurations = (item?.facilities || []).map((val, index) => ({
        //     id: val?.id,
        //     name: val?.abbreviation || '',
        //     address: associateAddress[index] == true ? val?.address : '',
        //     state_id: associateAddress[index] == true ? val?.state?.id : '',
        //     city_name: associateAddress[index] == true ? val?.city_name : '',
        //     zipcode: associateAddress[index] == true ? val?.zipcode : '',
        // }));
        // setValue('facilities', formattedDurations);

    //     if (item?.facilities?.length) {
    //         const stateArray = item?.facilities.map((val) => ({
    //             value: val?.state?.id,
    //             label: val?.state?.name
    //         }));

    //         setAllStates(stateArray);
    //     }
    // }, [item, setValue]);

    return (
        <>
            <hr />
            <div className="row-primary row-r justify-content-between flex-row">
                <h2 className='fst-italic'>Facilities</h2>
                <Button btnText='Add' buttonType='button' handleSubmit={handleAdd} />
            </div>

            {dynamicArray?.map((val, index) => {
                return (
                    <div className='w-100 biling_info' key={index}>
                        <div className='d-flex gap-1'>
                            <div className="row-primary w-100 align-items-center">
                                <h2>Facility name *</h2>
                                <div className='w-100'>
                                    <Controller
                                        name={`facilities.${index}.name`}
                                        control={control}
                                        rules={{
                                            required: "Please enter facility name"
                                        }}
                                        render={({ field }) => (
                                            <input className="input-in type_inp"
                                                type="text"
                                                name={`facilities.${index}.name`}
                                                placeholder='Name'
                                                {...field}
                                            />
                                        )}
                                    />
                                    {
                                        errors?.facilities?.length && errors?.facilities[index]?.name?.message &&
                                        <div style={{ marginBottom: 10 }}>
                                            <ErrorMessage text={errors?.facilities[index]?.name?.message} />
                                        </div>
                                    }
                                </div>
                            </div>
                            {dynamicArray?.length > 0 && (
                                <IconButton className="mb-3" color='error'
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        marginLeft: "auto",
                                    }}
                                    onClick={() => handleRemove(index)}
                                >
                                    <i className="fa-solid fa-trash-can trash_icon"></i>
                                </IconButton>
                            )}
                        </div>
                        <div className="row-primary align-items-center">
                            <h2></h2>
                            <h2 className='m-0'>Do you want to associate any address for this</h2>
                            <label className="custom-checkbox checkbox">
                                <input
                                    type="checkbox"
                                    name={`facilities.${index}.associateAddress`}
                                    checked={associateAddress[index] || false}
                                    onChange={() => handleCheckboxChange(index)}
                                />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        {associateAddress[index] && (
                            <div className='foam_page_row'>
                                <div className="row-primary">
                                    <h2>Street Address *</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name={`facilities.${index}.address`}
                                            control={control}
                                            rules={{
                                                required: "Please enter street address"
                                            }}
                                            render={({ field }) => (
                                                <input className="input-in type_inp"
                                                    type="text"
                                                    name={`facilities.${index}.address`}
                                                    placeholder='Address'
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {
                                            errors?.facilities?.length && errors?.facilities[index]?.address?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.facilities[index]?.address?.message} />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="row-primary">
                                    <h2>Select State *</h2>
                                    <Controller
                                        name={`facilities.${index}.state_id`}
                                        control={control}
                                        rules={{
                                            required: "Please select a state"
                                        }}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <AsyncPaginate
                                                    menuPlacement='auto'
                                                    styles={selectCustomStyles}
                                                    value={allStates?.length > 0 ? (allStates?.find((opt) => field.value == opt.value) || []) : null}
                                                    loadOptions={filteredStatesLoadOptions}
                                                    isClearable={false}
                                                    escapeClearsValue
                                                    onChange={(obj) => {
                                                        field.onChange(obj?.value);
                                                        handleCities(obj?.value, index)
                                                    }}
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                />
                                                {errors?.facilities?.length && errors?.facilities[index]?.state_id?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.facilities[index]?.state_id?.message} />
                                                    </div>
                                                }
                                            </div>
                                        }
                                    />
                                </div>

                                {/* <div className="row-primary">
                                    <h2>Select City *</h2>
                                    <Controller
                                        name={`facilities.${index}.city_id`}
                                        control={control}
                                        rules={{
                                            required: "Please select a City"
                                        }}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                {console.log(field.value, field.name, "allStates")}

                                                <Select
                                                    name={`facilities.${index}.city_id`}
                                                    {...field}
                                                    options={val?.cities || []}
                                                    value={val?.cities?.find((opt) => field.value == opt.value) || null}
                                                />

                                                {errors?.facilities?.length && errors?.facilities[index]?.city_id?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.facilities[index]?.city_id?.message} />
                                                    </div>
                                                }
                                            </div>
                                        }
                                    />
                                </div> */}

                                <div className="row-primary">
                                <h2>City Name *</h2>
                                <Controller
                                    name={`facilities.${index}.city_name`}
                                    control={control}
                                    rules={{
                                    required: "Please enter a city name",
                                    }}
                                    render={({ field }) => (
                                    <div className="w-100">
                                        <input
                                        className="input-in type_inp"
                                        type="text"
                                        placeholder="Enter City Name"
                                        {...field}
                                        />
                                        {errors?.facilities?.[index]?.city_name?.message && (
                                        <div style={{ marginBottom: 10 }}>
                                            <ErrorMessage text={errors.facilities[index].city_name.message} />
                                        </div>
                                        )}
                                    </div>
                                    )}
                                />
                                </div>


                                <div className="row-primary">
                                    <h2>Zip Code *</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name={`facilities.${index}.zipcode`}
                                            rules={{
                                                required: "Please enter zip code"
                                            }}
                                            control={control}
                                            render={({ field }) =>
                                                <input className="input-in type_inp" type="number" name={`facilities.${index}.zipcode`} placeholder="Zip Code"
                                                    {...field}
                                                />
                                            }
                                        />
                                        {errors?.facilities?.length && errors?.facilities[index]?.zipcode?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.facilities[index]?.zipcode?.message} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                        <hr />
                    </div>
                )
            })
            }
            <br />
            {/* <br /> */}
            {/* <br /> */}
        </>
    )
};

export default DynamicFacilities;